import { getDb } from '../LocalDB/LocalDB';
import { type Squawk } from './types';

export async function getSquawksForLeg(legId: string): Promise<Squawk[]> {
    return getDb().squawks.where({ legId }).sortBy('createdAt');
}
